import React from "react";

const previewText = (value, fallback) => String(value || "").trim() || fallback;

const SurveyHomeCardPreview = ({ form }) => (
  <div className="survey-mobile-home-card">
    <span className="survey-mobile-card-gift" role="img" aria-label="Gift">🎁</span>
    <h2>{previewText(form.title, "Survey title")}</h2>
    <p>{previewText(form.description, "Survey description shown to customers.")}</p>
    <span className="survey-mobile-card-action">Redeem</span>
  </div>
);

export default SurveyHomeCardPreview;
